export default __webpack_public_path__ + "static/media/home_selected.01224ccc.svg";